export interface ClientProfile {
  email: string;
  phone: string;
  firstName: string;
  lastName: string;
  birthDate?: string;
  createdBy: number;
  createdOn: string;
  accountId?: number;
  locationId?: number;
  payload?: string;
}

export interface CustomerMarketingEligibility {
  isEmailMarketingEnabled?: boolean | null;
  isSmsMarketingEnabled?: boolean | null;
}

export interface ClientProfileGetDto extends ClientProfile {
  id: string;
  locationId: number;
  marketingEligibility: CustomerMarketingEligibility;
}
export interface ClientProfileSearchDto {
  accountId?: number;
  locationId?: number;
  email: string;
  phone: string;
}

export interface ClientProfilePutDto extends ClientProfile {}

export interface ClientProfileStatisticsGetDto {
  totalAmount: number;
  lastTransactionDate: string;
  averageTransactionAmount: number;
  totalTransactions: number; // integer
}
